import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  class: "text-plain"
}

import { ref, watch, nextTick } from '../../../../../adapter-vue';
import {
  IMessageModel,
  TUITranslateService,
} from '@tencentcloud/chat-uikit-engine';
import { getBoundingClientRectSync } from '@tencentcloud/universal-api';
import { TranslationTextType, translator } from '../../../utils/translation';

interface IProps {
  message: IMessageModel;
  translationContentVisible: boolean;
  isSingleTranslation: boolean;
  translationWrapperRef: HTMLDivElement | undefined;
}

interface IEmits {
  (e: 'toggleErrorStatus', status: boolean): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'translation-content',
  props: {
    message: { default: () => ({} as IMessageModel) },
    translationContentVisible: { type: Boolean },
    isSingleTranslation: { type: Boolean },
    translationWrapperRef: {}
  },
  emits: ["toggleErrorStatus"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;
const props = __props;

const translationFinished = ref<boolean>(false);
const translationErrorText = ref<string>('');
const translationTextList = ref<TranslationTextType[]>([]);
const calculateHeight = ref<number>(0);
const calculateWidth = ref<number>(0);

const translationLoadingRef = ref<HTMLDivElement>();
const translationContentRef = ref<HTMLDivElement>();

watch(() => props.translationContentVisible, (newVal: boolean) => {
  if (newVal) {
    translator.get(props.message)
      .then((result) => {
        translationFinished.value = true;
        translationTextList.value = result;

        nextTick(() => {
          const { height: originHeight, width: originWidth } = getBoundingClientRectSync(translationLoadingRef.value!);
          const { height, width } = getBoundingClientRectSync(translationContentRef.value!);
          calculateHeight.value = originHeight;
          calculateWidth.value = originWidth;
          requestAnimationFrame(() => {
            calculateHeight.value = height;
            calculateWidth.value = width;
            if (props.isSingleTranslation) {
              nextTick(() => {
                const { bottom } = getBoundingClientRectSync(props.translationWrapperRef);
                const { bottom: bottomWindow } = getBoundingClientRectSync('#messageScrollList');
                if (bottom > bottomWindow) {
                  const timer = setTimeout(() => {
                    props.translationWrapperRef!.scrollIntoView({ block: 'end', behavior: 'smooth' });
                    clearTimeout(timer);
                  }, 150);
                }
              });
            }
          });
        });
      })
      .catch((err) => {
        translationFinished.value = true;
        const { height: originHeight } = getBoundingClientRectSync(translationLoadingRef.value!);
        calculateHeight.value = originHeight;
        translationTextList.value = [];
        emits('toggleErrorStatus', true);
        translationErrorText.value = err.message;
      });
  }
}, { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "message-translation-container",
    style: _normalizeStyle({
      height: _unref(calculateHeight) > 0 ? `${_unref(calculateHeight)}px` : 'auto',
      width: _unref(calculateWidth) > 0 ? `${_unref(calculateWidth)}px` : 'auto',
    })
  }, [
    (_unref(translationFinished))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "translationContentRef",
          ref: translationContentRef,
          class: _normalizeClass({
        'translation-content': true,
        'occur': _unref(calculateHeight) > 0,
      })
        }, [
          (_unref(translationTextList).length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(translationTextList), (text, index) => {
                return (_openBlock(), _createElementBlock("span", { key: index }, [
                  (text.type === 'face')
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "text-face",
                        src: text.value
                      }, null, 8, _hoisted_1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(text.value), 1))
                ]))
              }), 128))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_unref(translationErrorText)), 1)
              ], 64))
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref_key: "translationLoadingRef",
      ref: translationLoadingRef,
      class: _normalizeClass({
        'loading': true,
        'loading-end': _unref(translationFinished)
      })
    }, _toDisplayString(_unref(TUITranslateService).t('TUIChat.翻译中')) + "... ", 3)
  ], 4))
}
}

})